import { QueryClient } from '@tanstack/react-query';

/**
 * Retry transient failures once, but never client errors — a 403/404 will
 * fail identically on retry, and a paused retry (offline flap) leaves the
 * query stuck in 'pending' so error UI never renders.
 */
export function retryUnlessClientError(failureCount: number, error: unknown): boolean {
  const status = (error as { response?: { status?: number } } | null)?.response?.status;
  if (status && status >= 400 && status < 500) return false;
  return failureCount < 1;
}

/**
 * Query keys are namespaced [orgId, groupId, feature, ...] so org/group
 * switches isolate caches. AuthContext calls queryClient.clear() on org switch.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 10 * 60_000,
      retry: retryUnlessClientError,
      refetchOnWindowFocus: false,
    },
  },
});
